module.exports = "<app-breadcrumb  *ngIf=\"!lockStatus && details?.type=='breadcrumb'\" [data]=\"details.data\"></app-breadcrumb>\r\n<button *ngIf=\"lockStatus\" type=\"button\" class=\"btn float-left btn-secondary mt-2\" (click)=\"closeClicked()\">Close</button>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/Fed/src/app/shared/components/sub-header/left-section/left-section.component.html
// module id = ../../../../../src/app/shared/components/sub-header/left-section/left-section.component.html
// module chunks = main